module.exports = __webpack_public_path__ + "img/changzhou.9866890.png";